/**
 * User: herbert
 * Date: 12.02.16
 * Time: 11:18
 */
// codes MUST equal the key in COLORS in translate.js
export default [
	{
		id: 'seluxGraphite',
		code: '',
		color: 'rgb(123,130,130)'
	},
	{
		id: 'ral9005',
		code: 'RAL 9005',
		color: 'rgb(0,0,0)'
	},
	{
		id: 'ral7016',
		code: 'RAL 7016',
		color: 'rgb(8,50,56)'
	},
	{
		id: 'ral7024',
		code: 'RAL 7024',
		color: 'rgb(36,69,81)'
	},
	{
		id: 'ral7011',
		code: 'RAL 7011',
		color: 'rgb(36,68,71)'
	},
	{
		id: 'ral9007',
		code: 'RAL 9007',
		color: 'rgb(149,143,140)'
	},
	{
		id: 'ral9006',
		code: 'RAL 9006',
		color: 'rgb(176,187,195)'
	},
	{
		id: 'ral9010',
		code: 'RAL 9010',
		color: 'rgb(254,253,242)'
	},
	{
		id: 'ral9016',
		code: 'RAL 9016',
		color: 'rgb(242,248,251)'
	},
	{
		id: 'ral6009',
		code: 'RAL 6009',
		color: 'rgb(0,56,30)'
	},
	{
		id: 'ral6005',
		code: 'RAL 6005',
		color: 'rgb(0,84,59)'
	},
	{
		id: 'ral5003',
		code: 'RAL 5003',
		color: 'rgb(0,30,66)'
	},
	{
		id: 'ral3005',
		code: 'RAL 3005',
		color: 'rgb(154,15,40)'
	},
	{
		id: 'ral3003',
		code: 'RAL 3003',
		color: 'rgb(181,13,33)'
	},
	{
		id: 'db703',
		code: 'DB703',
		color: 'rgb(165,172,175)'
	},
	{
		id: 'db702',
		code: 'DB702',
		color: 'rgb(129,131,134)'
	},
	{
		id: 'db701',
		code: 'DB701',
		color: 'rgb(167,168,171)'
	}
];
